
<div class="faqs-container my-5 px-1 px-md-5">
    <h2 class="title text-center mb-0" v-html="title"></h2>
    <div v-if="description" v-html="description"></div>
    <div class="faq-container" v-for="(faq, index) in faqs" :id="'faq-' + index">
        <div class="faq-header d-flex" :id="'faq-header-' + index" @click="toggleCard(index)">
            <i class="fa-sharp mr-3" :class="custom_faqs ? 'fa-chevron-down-custom' : 'fa-chevron-right'"
               :id="'faq-arrow-' + index"></i>
            <h3 class="faq-question" style="font-size: 16px; color: gray" :id="'faq-question-' + index"><span>{{ faq.pregunta }}</span>
            </h3>
        </div>
        <div class="faq-body" :id="'faq-body-' + index" v-html="faq.respuestas ? faq.respuestas : faq.respuesta">
        </div>
    </div>
</div>
